export function extractRootOrganisatieFromPath() {
    const { pathname } = location;
    const index = pathname.indexOf("/", 1);
    return index != -1 ? pathname.substring(1, index) :null;
}
